// extracted by mini-css-extract-plugin
export var compactFilters = "_f7-4";
export var detailImage = "_f7-1";
export var dropdownContainer = "_f7-2";
export var imageContainer = "_f7-0";
export var selectedCard = "_f7-3";